(function (app, ng) {
    app.component('generalTrainingComponent',
        {
            templateUrl: 'App.Portal/States/CarriersTraining/Components/GeneralTraining/GeneralTraining.template.html',
            controller: 'GeneralTrainingController',
            bindings: {
                trainings: '<',
            }
        })
        .controller('GeneralTrainingController', [function () {
            var $ctrl = this;
        }]);
})(window.app, window.angular); //jshint ignore:line